export default(time,fmt)=>{
    var minute=60;
    var hour=24*minute;
    var day= hour * 30
    if(time<minute){
        fmt=time+'分钟'
    }else if(time<hour&&time>=minute){
 
        var s=parseInt(time/minute)
        var d=time%minute
        fmt=s+"小时"+d+"分钟"
    }else if(time<day&&time>=hour){
        var s=parseInt(time/hour)
        var d=parseInt(time%hour/minute)
        var c=time%hour%minute
        fmt=s+"天"+d+"小时"+c+"分钟"
    }else{
        var s=parseInt(time/hour)
        fmt=s+"天"
    }
    return fmt
}


// WEBPACK FOOTER //
// ./src/Filters/TimeFormat.js